import { Gift, Star } from 'lucide-react';

const topGifts = [
  'Premium Dattel-Box – klassisches Eid Geschenk',
  'Halal Parfum-Set für Frauen',
  'Gebetskette / Tasbih',
  'Kinderbücher & Malbücher',
  'DIY Kinder Aktivitätssets',
  'Dekoration für Zuhause zu Eid',
  'Schmuck-Geschenksets',
  'Oud / Attar Duftöl für Männer',
  'Home-Spa Sets für Frauen',
  'Süßigkeiten- und Snack-Körbe',
];

export const TopGiftsSection = () => {
  return (
    <section className="py-16 md:py-24 bg-[#F5F5F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <span className="text-sm font-medium tracking-widest uppercase text-[#4A5D4F] mb-4 block">
            Inspiration
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-medium text-[#2C332E] mb-4">
            Die beliebtesten Eid Geschenke
          </h2>
          <p className="text-lg text-[#6B7280] max-w-2xl mx-auto">
            Entdecke unsere Top 10 Geschenkideen für Eid ul Fitr und Eid ul Adha
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto">
          {topGifts.map((gift, index) => (
            <div
              key={index}
              className="flex items-center gap-4 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#4A5D4F]/10 flex items-center justify-center">
                <span className="text-sm font-bold text-[#4A5D4F]">{index + 1}</span>
              </div>
              <p className="text-[#2C332E] font-medium">{gift}</p>
              {index < 3 && <Star className="w-4 h-4 text-[#D4C5A9] flex-shrink-0 ml-auto" />}
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-[#6B7280] mt-8">
          <Gift className="w-4 h-4 inline-block mr-1" />
          Alle Produkte sind sorgfältig ausgewählt, um das perfekte Eid Geschenk zu finden.
        </p>
      </div>
    </section>
  );
};
